<div class="page">

    <div class="page-name">Manage Users</div>

            <div class="row">
                <div class="col-12"> 
                    <div class="tab-sec">
                        <div class="tab-block">
                            <div class="tab border-right" tabindex="0">
                                    <a class="tab-link" routerLinkActive="active"  [routerLink]="'manage-user'">
                                    Add/Edit Users
                                    </a>
                            </div>
                            <div class="tab" tabindex="0">
                                <a class="tab-link" routerLinkActive="active"  [routerLink]="'psr-manage-user'">
                                    PSR Distribution Group
                                </a>
                            </div>
                        </div>
                            
                    </div>
                    <div class="content">
                        <router-outlet></router-outlet>
                    </div>
                </div>
            </div>

</div>